import React from 'react';
import Webcam from "react-webcam";
import { connect } from 'react-redux'
import * as actionCreators from '../../store/Action'
import Visitor_Upload from '../../assets/img/visitor_upload/upload.svg'
import { MDBModal, MDBModalBody, MDBModalHeader } from "mdbreact";
import { Col, Row } from "reactstrap";
import { Button as SementicBtn } from "semantic-ui-react";
import * as actionCreator from "../../store/Action";
import {withTranslation} from "react-i18next";

class VisitorPhotoUpload extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            modal: false,
            screenshot: '',
            defaultimage: true,
            visitorimage: false,
            facingFront:true
        };
    }

    screenshot = () => {
        let screenshot = this.refs.webcam.getScreenshot();
        this.setState({
            screenshot: screenshot,
            modal: false,
            defaultimage: false,
            visitorimage: true
        });
        this.props.screenshotHandler(screenshot);
    };

    toggle = () => {
    };

    modal = () => {
        this.setState({
            modal: true
        });
    };

    handleFacingMode = () => {
      this.setState({facingFront: !this.state.facingFront})
    }

    render() {
      let {facingFront} = this.state;
        let $imagePreview = null;
        if (this.props.screenshot !== '') {

        } else {
            $imagePreview = (
                <div className="previewText"
                    style={this.props.image ? isImage : isNotImage}
                >
                    <img style={this.props.image ? isImageTag : isNotImageTag}
                        src={this.props.image ? this.props.image : Visitor_Upload} />
                </div>);
        }
        const {t} = this.props;
     return (
            <div className="previewComponent">
              {
                this.state.modal ?
                  <div className={"visitor-image-modal"} isOpen={true} toggle={this.toggle} size="md" centered={true}>
                    <MDBModalHeader className={"title"} toggle={()=>this.setState({modal:false})}>
                      {/*Get Visitor Image*/}
                    </MDBModalHeader>

                    <MDBModalBody style={{ padding: '0px' }}>
                      <Webcam
                        forceScreenshotSourceSize={true}
                        mirrored={false}
                        imageSmoothing={true}
                        screenshotQuality={100}
                        onUserMediaError={() => {}}
                        onUserMedia={() => {}}
                        videoConstraints={{facingMode: facingFront ? "user" : { exact: "environment" }}}
                        style={{ width: '100%' }}
                        audio={false}
                        screenshotFormat="image/jpeg"
                        ref='webcam'
                      />
                      <br/>

                      <Row>
                        <Col className={"align-center"} style={{ marginTop: "2vh" }}>
                          <SementicBtn style={{ width: "10vw" }} className="px-5 search-visitor-btn"
                                       onClick={this.screenshot.bind(this)}
                          >{t('capture')}</SementicBtn>
                          <SementicBtn style={{ height:'100%', marginLeft:'10px' }} icon='sync'
                                       onClick={this.handleFacingMode.bind(this)}
                          />
                        </Col>
                      </Row>
                      <br/>
                    </MDBModalBody>
                  </div>
                  : null
              }
                <form
                >
                    <input className="fileInput"
                        type="file"
                        accept="image/png, image/jpeg"
                        style={{
                            display: 'none',
                            cursor: 'pointer',
                            zIndex: '1',
                            position: 'absolute',
                            marginTop: '0%',
                            opacity: '0',
                            width: '200px',
                            height: '150px',
                        }}

                    />
                </form>
                <label
                    onClick={this.modal}

                    className="imgPreview" style={{
                        textAlign: 'center',
                        boxShadow: '0px 15px 20px rgba(0, 0, 0, 0.1)',
                        backgroundColor: this.props.white ? '#00ff51' : '#414141',
                        background: 'transparent',
                        width: '200px',
                        height: '150px',
                        marginBottom: '34px'
                    }}>
                    {
                        this.state.defaultimage ?
                            $imagePreview
                            : null
                    }

                    {
                        this.props.screenshot ?
                            <img src={this.props.screenshot} style={{
                                width: '200px',
                                height: '150px',
                                objectFit: 'scale-down',
                                // border: '1px #9a9a9a dotted',
                              boxShadow: '0px 0px 6px rgba(0, 0, 0, 0.161)',
                                cursor: 'pointer'
                            }} />
                            : null
                    }

                </label>



            </div>
        )
    }
}

let isImageTag = {
    height: '200px',
    width: '150px',
    objectFit: 'contain'
};

let isNotImageTag = {
    height: '45%',
};


let isImage = {
    width: '200px',
    height: '150px',
    color: 'white',
    // border: '1px #9a9a9a dotted',
  boxShadow: '0px 0px 6px rgba(0, 0, 0, 0.161)',
    cursor: 'pointer'
};
let isNotImage = {
    width: '200px',
    height: '150px',
    color: 'white',
    paddingTop: '30%',
    // border: '1px #9a9a9a dotted',
  boxShadow: '0px 0px 6px rgba(0, 0, 0, 0.161)',
    cursor: 'pointer'
};

const mapStateToProps = (state) => ({
    usr_obj: state.userReducer.user,
    all_available_card: state.reception_SheduleMeetingReducer.all_available_card,
});

const mapDispatchToProps = (dispatch) => {
    return {
        imageUploaderHandler: (image) => dispatch(actionCreators.imageUploaderHandler(image)),
        // spinner handler
        spinnerHandler: (data) => dispatch(actionCreator.spinnerHandler(data)),
        // all available cards
        receptionAllAvailableCardHandler: (data) => dispatch(actionCreator.receptionAllAvailableCardHandler(data))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(VisitorPhotoUpload));
